module.exports = __webpack_public_path__ + "src/img/zalando/ads.1e2fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/ads.jpg
// module id = 259
// module chunks = 0